import React, { useState, useContext } from "react";
import ImageSelected from "../face/imageselected";
import { uploadSlipImage } from "./../../services/car";
import { toast } from "react-toastify";

import dlv from "dlv";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const ModalImage = ({
  button1,
  isOpen,
  header,
  onCancel,
  onConfirm,
  message,
  list,
  from,
  to,
  onDisAprove,
  value,
  onChange,
  total,
  error,
  year,
  id,
}) => {
  const [photos, setphotos] = useState([]);
  const [onSave, setonSave] = useState(false);


  const notifyPhotoSelector = (files) => {
    // console.log(files);
    setphotos(files);
  };

  const confirmsave = () => {
    doSubmit();
    //  onConfirm();
  };

  const doSubmit = async () => {
    const getPhoto = photos.find((x) => x);
    // console.log(getPhoto.setMetadata.file);
    let photoBase64 = "";
    // let photoBase64Original=""
    try {
      //console.log(getPhoto)
      //getFileEncodeBase64String

      //  photoBase64 =  await getPhoto.getFileEncodeBase64String() ;
      // photoBase64Original = await getPhoto.getFileEncodeDataURL() ;
      // console.log('base64 trim', photoBase64)
      // console.log('base64 trim', photoBase64Original)
      //  photoBase64 = await convertBase64(getPhoto)
      photoBase64 = getPhoto ? await getPhoto.getFileEncodeDataURL() : "";
    } catch (err) {
      //console.log('Error',err);
    }

    if (!photoBase64) return toast.error("ไม่พบข้อมูลรูปภาพ");

    if (photoBase64.includes("data:image/png;base64,"))
      photoBase64 = photoBase64.replace("data:image/png;base64,", "");
    if (photoBase64.includes("data:image/jpg;base64,"))
      photoBase64 = photoBase64.replace("data:image/jpg;base64,", "");
    if (photoBase64.includes("data:image/jpeg;base64,"))
      photoBase64 = photoBase64.replace("data:image/jpeg;base64,", "");
    // console.log('base64 trim', photoBase64)
    // ublic string month { get; set; }
    // public string year { get; set; }
    // public int id { get; set; }
    // public string appcode { get; set; }
    // public string ImageData { get; set; }
    // public decimal total { get; set; }
    // public int totalmonth { get; set; }
    const doc = {
      year,
      id,
      imagedata: photoBase64,
      total: total,
      totalmonth: value.length,
      startmonth: from,
      endmonth: to,
    };

   
     setonSave(true)
    const { data: result } = await uploadSlipImage(doc);
    if (result.status === "success") {
      toast.success("upload เสร็จเรียบร้อย");
      setonSave(false)
      onConfirm();
    } else {
      toast.error(result.message);
      setonSave(false)
    }
  };

  // const convertBase64 = (file) =>{
  //   console.log(file);

  //   return new Promise((resolve, reject) =>{
  //     const fileReader = new FileReader();
  //     fileReader.readAsDataURL(file);

  //     fileReader.onload =()=>{
  //       resolve(fileReader.result);
  //     };
  //     fileReader.onerror = (error) =>{
  //       reject(error);
  //     };
  //   });
  // };
  //console.log(photos)

  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={onCancel}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <ModalHeader></ModalHeader>
        <ModalBody>
          <ImageSelected notifyFileUpload={notifyPhotoSelector} />
        </ModalBody>

        {error && <div className="col-md-12 alert alert-danger"> {error}</div>}
        {message && (
          <div className="col-md-12 alert alert-warning"> {message}</div>
        )}
        {list && list.comment && <Button color="danger">{list.comment}</Button>}
        <ModalFooter>
          {photos && photos.length > 0 && (
            <Button color="primary"    disabled ={onSave} onClick={confirmsave}>
              บันทึก
            </Button>
          )}

          <Button color="secondary" onClick={onCancel}>
            ยกเลิก
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ModalImage;
